import { Text } from "@imminently/react/ui/core/text";
import { SxProps, Tooltip } from "@mui/material";
import { Variant } from "@mui/material/styles/createTypography";
import { PropsWithChildren } from "react";

import { Theme } from "@/theme";

const styles = {
  normalUnderline: {
    borderBottom: "1px #0000004D dashed",
  },
  warningUnderline: {
    borderBottom: "1px #f00 dashed",
  },
};

type TooltipTextProps = PropsWithChildren & {
  text: string;
  variant?: Variant;
  warning?: boolean;
  sx?: SxProps<Theme>;
};

/**
 * If children are provided this makes a text component that
 * has a tooltip on hover with children as contents. Otherwise render a
 * regular Text component
 */
const TooltipText = (props: TooltipTextProps) => {
  const { text, variant, warning, sx, children } = props;

  if (!children) {
    return (
      <Text variant={variant} sx={sx}>
        {text}
      </Text>
    );
  }

  const style = {
    ...(warning ? styles.warningUnderline : styles.normalUnderline),
    ...sx,
  };

  return (
    <Tooltip title={children} arrow>
      <Text variant={variant} sx={style}>
        {text}
      </Text>
    </Tooltip>
  );
};

export default TooltipText;
